var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"narrow-container"},[_c('f-view-heading',{attrs:{"title":_vm.$t('epoch.detail_title')}}),_c('f-epoch-detail',{attrs:{"id":parseInt(_vm.$route.params.id) + 1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }